module.exports = __webpack_public_path__ + "static/media/museu.1440cd55.svg";